// extracted by mini-css-extract-plugin
export default {"content":"contact_content__TWhQW","map":"contact_map__eSOan","item":"contact_item__mJYlT"};